/*
 * Aoiro.shop custom scripts
 *
 * お届け予定日の表記変更
 * 配送予定日アプリ（Estimated Delivery Date）がカート投入時に付ける
 *   properties[Estimated between] = "26/10/14 and 26/10/15"（YY/MM/DD）
 * を、カートに追加する直前に
 *   properties[お届け予定] = "10月14日～10月15日"
 * へ書き換えます。カート画面では「10月14日～10月15日お届け予定」と表示されます。
 * 日付が読み取れない場合は書き換えず、アプリの元の値をそのまま送ります。
 */
(function () {
  var SOURCE_NAME = 'properties[Estimated between]';
  var TARGET_NAME = 'properties[お届け予定]';

  function toJa(part) {
    // YY/MM/DD または YYYY/MM/DD（区切りは / - . に対応）
    var m = part.match(/(\d{2,4})[\/\-.](\d{1,2})[\/\-.](\d{1,2})/);
    if (!m) return null;
    return parseInt(m[2], 10) + '月' + parseInt(m[3], 10) + '日';
  }

  function format(value) {
    if (!value) return null;
    var parts = value.split(/\s+(?:and|-|~|～|to)\s+/i);
    var from = toJa(parts[0]);
    if (!from) return null;
    var to = parts[1] ? toJa(parts[1]) : null;
    if (parts[1] && !to) return null;
    return to && to !== from ? from + '～' + to : from;
  }

  function convert(form) {
    if (!form || !form.querySelectorAll) return;
    form.querySelectorAll('input[data-aoiro-eta]').forEach(function (el) { el.remove(); });
    form.querySelectorAll('input[name="' + SOURCE_NAME + '"]').forEach(function (input) {
      var ja = format(input.value);
      if (!ja || input.disabled) return;
      // 書き換え後の値を別の入力として追加し、元の入力は送信の間だけ無効化
      // （アプリ側の入力欄はそのまま残すので、バリエーション変更後も正しく更新されます）
      var target = document.createElement('input');
      target.type = 'hidden';
      target.name = TARGET_NAME;
      target.value = ja;
      target.setAttribute('data-aoiro-eta', '');
      input.insertAdjacentElement('afterend', target);
      input.disabled = true;
      setTimeout(function () {
        input.disabled = false;
      }, 0);
    });
  }

  // Dawn の product-form より先に実行されるよう capture フェーズで処理
  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target;
      if (form && form.action && form.action.indexOf('/cart/add') !== -1) convert(form);
    },
    true
  );

  // カート表示: 「お届け予定: 10月14日～10月15日」→「10月14日～10月15日お届け予定」
  // （カートページ・カート通知・カートドロワーは再描画されるため MutationObserver で都度適用）
  var LABEL = 'お届け予定';
  function relabel(root) {
    (root || document).querySelectorAll('.product-option:not([data-aoiro-eta])').forEach(function (opt) {
      var dt = opt.querySelector('dt');
      var dd = opt.querySelector('dd');
      if (!dt || !dd) return;
      if (dt.textContent.replace(/[:：\s]/g, '') !== LABEL) return;
      opt.setAttribute('data-aoiro-eta', '');
      dt.classList.add('visually-hidden');
      dd.textContent = dd.textContent.trim() + LABEL;
    });
  }
  function start() {
    relabel(document);
    new MutationObserver(function (records) {
      for (var i = 0; i < records.length; i++) {
        if (records[i].addedNodes.length) {
          relabel(document);
          break;
        }
      }
    }).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
